function initSlider(){
    const containers = window.document.querySelectorAll('.js_custom-slider');
    
    if(containers.length < 1) return;

    containers.forEach(container => {
        const options = {
            contain:true,
            cellAlign:'left',
            percentPosition:false,
            pageDots:false,
            prevNextButtons:false,
            wrapAround:true,
            initialIndex:0,
            watchCSS: true
        };
        const slider = new Flickity(container,options); 
        const onlyMobileAttr = container.getAttribute('data-custom-slider-only-mobile');
        const onlyMobile = onlyMobileAttr && onlyMobileAttr === 'true' ? true : false;
        if(onlyMobile)
            container.classList.add('only-mobile');
    });
    
}
window.addEventListener('load',initSlider);
